// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';

import Icon from 'presentations/views/components/atoms/Icon';
import Link from 'presentations/views/components/atoms/Link';
import Button from 'presentations/views/components/atoms/Button';

import {
  borderRadius,
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import { gray01, gray04, white } from 'presentations/views/styles/color';

import ConfirmRequestAcceptDialog from '../ConfrimRequestAcceptDialog';
import ConfirmRequestDeclineDialog from '../ConfrimRequestDeclineDialog';

import { Props } from './types';
import { useConfirmRequestButton } from './hooks';

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  const { state, actions } = useConfirmRequestButton(props);

  return (
    <>
      <StyledContainer>
        <StyledLabelContainer>
          <StyledLabel>{t('label')}</StyledLabel>
          <StyledLink href="" target="_blank">
            <StyledIcon name="help" />
          </StyledLink>
        </StyledLabelContainer>
        <StyledButtonContainer>
          <StyledButton
            isLoading={props.isRequestDeclineLoading}
            isDisabled={props.isRequestAcceptLoading}
            size="large"
            color="inherit"
            onClick={actions.onClickDeclineButton}
          >
            {t('decline')}
          </StyledButton>
          <StyledButton
            isLoading={props.isRequestAcceptLoading}
            isDisabled={
              props.isRequestDeclineLoading || props.isRequestAcceptDisabled
            }
            size="large"
            color="primary"
            onClick={actions.onClickAcceptButton}
          >
            {t('accept')}
          </StyledButton>
        </StyledButtonContainer>
      </StyledContainer>
      <ConfirmRequestAcceptDialog
        isOpen={state.isOpenConfirmRequestAcceptDialog}
        eventCount={state.duplicateScheduleEvents.length}
        onClickSubmit={actions.onClickSubmitAcceptButton}
        onClickCancel={actions.onClickCancelDialog}
      />
      <ConfirmRequestDeclineDialog
        isOpen={state.isOpenConfirmRequestDeclineDialog}
        onClickSubmit={actions.onClickSubmitDeclineButton}
        onClickCancel={actions.onClickCancelDialog}
      />
    </>
  );
}

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: ${spacing(12)} ${spacing(16)};
  border-radius: ${borderRadius(12)};
  border: 1px solid ${gray04};
  background: ${white};

  ${mediaMax.tablet} {
    flex-direction: column;
    align-items: center;
    padding: ${spacing(16)};
  }
`;
const StyledLabelContainer = styled.div`
  display: flex;
  align-items: center;
`;
const StyledLabel = styled.div`
  font-size: ${fontSize(16)};
  font-weight: ${fontWeight('bold')};
`;
const StyledIcon = styled(Icon)`
  margin-left: ${spacing(6)};
  color: ${gray01};
  width: 18px !important;
  height: 18px !important;
`;
const StyledButtonContainer = styled.div`
  display: flex;
  align-items: center;

  ${mediaMax.tablet} {
    margin-top: ${spacing(16)};
  }
`;
const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;
const StyledButton = styled(Button)`
  width: 140px;
  &:last-child {
    margin-left: ${spacing(12)};
  }

  ${mediaMax.tablet} {
    max-width: 100%;
  }
`;
